import { Link, NavLink, Outlet } from 'react-router';
import Logo from '@/components/Logo';
import { useLogout } from '@/lib/session';
import type { MeResponse } from '@/lib/api';
import { cn } from '@/lib/utils';

const TABS = [
  { to: '/admin/dashboard', label: 'Tableau de bord' },
  { to: '/admin/orders', label: 'Commandes' },
  { to: '/admin/claims', label: 'Réclamations Prix' },
  { to: '/admin/rewards', label: 'Cadeaux' },
  { to: '/admin/reps', label: 'Rôles' },
  { to: '/admin/lines', label: 'Lignes' },
  { to: '/admin/customers', label: 'Clients' },
  { to: '/admin/catalogue', label: 'Catalogue' },
  { to: '/admin/promotions', label: 'Promotions' },
  { to: '/admin/settings', label: 'Paramètres' },
];

export default function AdminLayout({ session }: { session: MeResponse }) {
  const logout = useLogout();

  return (
    <div className="min-h-full">
      <header className="bg-card border-b">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 p-4">
          <div className="flex items-center gap-4">
            <Logo className="h-10" />
            <div>
              <h1 className="text-xl font-bold">Administration</h1>
              <p className="text-muted-foreground text-sm">{session.user.fullName}</p>
            </div>
          </div>
          {/* Imports/Export, puis Déconnexion tout à droite. */}
          <div className="flex items-center gap-2">
            <Link
              to="/admin/imports"
              className="border-input flex h-10 items-center rounded-lg border px-4 text-sm font-medium"
            >
              Imports
            </Link>
            <Link
              to="/admin/export"
              className="border-input flex h-10 items-center rounded-lg border px-4 text-sm font-medium"
            >
              Export
            </Link>
            <button
              onClick={() => logout.mutate()}
              className="border-input h-10 rounded-lg border px-4 text-sm font-medium"
            >
              Déconnexion
            </button>
          </div>
        </div>
        <nav className="mx-auto flex max-w-6xl gap-1 overflow-x-auto px-4">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                cn(
                  'border-b-2 px-4 py-3 text-sm font-medium whitespace-nowrap transition-colors',
                  isActive
                    ? 'border-primary text-foreground'
                    : 'text-muted-foreground border-transparent hover:text-foreground',
                )
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="mx-auto max-w-6xl p-6">
        <Outlet />
      </main>
    </div>
  );
}
